import { Icon24Folder } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const Cards3IconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_36_499)">
        <path
          d="M19.5 9H4.5C4.08579 9 3.75 9.33579 3.75 9.75V18.75C3.75 19.1642 4.08579 19.5 4.5 19.5H19.5C19.9142 19.5 20.25 19.1642 20.25 18.75V9.75C20.25 9.33579 19.9142 9 19.5 9Z"
          stroke="currentColor"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5.25 6H18.75" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.75 3H17.25" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_36_499">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Cards3Icon = fplIcon(Cards3IconLocal, Icon24Folder);
